export const quantity = [/\d/, /\d/, /\d/, /\d/, /\d/]

export const getNumericMask = (numberOfDigits = 10) => new Array(numberOfDigits).fill(/\d/)
